var InFlight = InFlight || {};
InFlight.CMS = (function () {

    var api = {
        token: "MC5YaThmM0JBQUFDTUFzZS1l.77-9Re-_vS5H77-9S--_ve-_vTNjXVIXXUMaPgvvv73vv71sCwIA77-9RO-_ve-_ve-_ve-_ve-_vQ",
        endPoint: "https://ccsf.cdn.prismic.io/api/v2"
    };

    var getFAQ = function () {
        var query = PrismicJS.getApi(api.endPoint, { accessToken: api.token }).then(function (api) {
            return api.query(
                PrismicJS.Predicates.at('document.type', 'faq-question')
            );
        }).then(function (response) {
            var sections = [];
            response.results.forEach(function (section_raw) {
                var normalized = _normalizeBase(section_raw);
                var result = $.extend(normalized, {
                    description: PrismicDOM.RichText.asText(section_raw.data.description),
                    faqs: $.map(section_raw.data["faq-body"], function (faq) {
                        return {
                            question: PrismicDOM.RichText.asText(faq.question, null, _htmlSerializer),
                            answer: PrismicDOM.RichText.asHtml(faq.answer, null, _htmlSerializer)
                        }
                    })
                });
                sections.push(result);
            })
            return sections;
        }, function (err) {
            return err;
        });
        return query;
    }

    var getContact = function () {
        var query = PrismicJS.getApi(api.endPoint, { accessToken: api.token }).then(function (api) {
            return api.query(
                PrismicJS.Predicates.at('document.type', 'page-contact')
            );
        }).then(function (response) {
            var sections = [];
            response.results.forEach(function (section_raw) {
                var normalized = _normalizeBase(section_raw);
                var result = $.extend(normalized, {
                    description: PrismicDOM.RichText.asText(section_raw.data.description),
                    services: $.map(section_raw.data["services"], function (service) {
                        return {
                            name: PrismicDOM.RichText.asText(service.name, null, _htmlSerializer),
                            content: PrismicDOM.RichText.asHtml(service.content, null, _htmlSerializer)
                        }
                    })
                });
                sections.push(result);
            })
            return sections;
        }, function (err) {
            return err;
        });

        return query;
    }

    var getTraining = function () {
        var query = PrismicJS.getApi(api.endPoint, { accessToken: api.token }).then(function (api) {
            return api.query(
                PrismicJS.Predicates.at('document.type', 'page-training')
            );
        }).then(function (response) {
            var sections = [];
            response.results.forEach(function (section_raw) {
                var normalized = _normalizeBase(section_raw);
                var result = $.extend(normalized, {
                    description: PrismicDOM.RichText.asText(section_raw.data.description),
                    aidSection: {
                        title: PrismicDOM.RichText.asText(section_raw.data["aid-section-title"]),
                        description: PrismicDOM.RichText.asHtml(section_raw.data["aid-section-description"]),
                        links: $.map(section_raw.data["aid-section-links"], function (link) {
                            return {
                                text: PrismicDOM.RichText.asText(link.text, null, _htmlSerializer),
                                link: link.link.url
                            }
                        })
                    }
                });
                sections.push(result);
            })
            return sections;
        }, function (err) {
            return err;
        });

        return query;
    }

    var getNewFeatures = function () {
        var query = PrismicJS.getApi(api.endPoint, { accessToken: api.token }).then(function (api) {
            return api.query(
                PrismicJS.Predicates.at('document.type', 'page-new-feature')
            );
        }).then(function (response) {
            var sections = [];
            response.results.forEach(function (section_raw) {
                var normalized = _normalizeBase(section_raw);
                var result = $.extend(normalized, {
                    description: PrismicDOM.RichText.asText(section_raw.data.description),
                    releases: $.map(section_raw.data["releases"], function (release) {
                        return {
                            name: PrismicDOM.RichText.asText(release.name, null, _htmlSerializer),
                            features: PrismicDOM.RichText.asHtml(release.features, null, _htmlSerializer)
                        }
                    })
                });
                sections.push(result);
            })
            return sections;
        }, function (err) {
            return err;
        });
        return query;
    }

    var getSiteBanner = function () {
        var query = PrismicJS.getApi(api.endPoint, { accessToken: api.token }).then(function (api) {
            return api.query(
                PrismicJS.Predicates.at('document.type', 'page-site-banner')
            );
        }).then(function (response) {
            var sections = [];
            response.results.forEach(function (section_raw) {
                var normalized = _normalizeBase(section_raw);
                var result = $.extend(normalized, {
                    content: PrismicDOM.RichText.asHtml(section_raw.data["message"], null, _htmlSerializer)
                });
                sections.push(result);
            })
            return sections;
        }, function (err) {
            return err;
        });
        return query;
    }

    var getEmergencyVendors = function () {
        var query = PrismicJS.getApi(api.endPoint, { accessToken: api.token }).then(function (api) {
            return api.query(
                PrismicJS.Predicates.at('document.type', 'page-emergency-vendors')
            );
        }).then(function (response) {
            var sections = [];
            response.results.forEach(function (section_raw) {
                var normalized = _normalizeBase(section_raw);
                var result = $.extend(normalized, {
                    title: PrismicDOM.RichText.asText(section_raw.data["title"]),
                    description: PrismicDOM.RichText.asText(section_raw.data["description"]),
                    content: PrismicDOM.RichText.asHtml(section_raw.data["content"], null, _htmlSerializer)
                });
                sections.push(result);
            })
            return sections;
        }, function (err) {
            return err;
        });
        return query;
    }

    function getSiteMaintenance() {
        var query = PrismicJS.getApi(api.endPoint, { accessToken: api.token }).then(function (api) {
            return api.query(
                PrismicJS.Predicates.at('document.type', 'page-site-maintenance')
                );
        }).then(function (response) {
            var sections = [];
            response.results.forEach(function (section_raw) {
                var normalized = _normalizeBase(section_raw);
                var result = $.extend(normalized, {
                    title: PrismicDOM.RichText.asText(section_raw.data["title"]),
                    description: PrismicDOM.RichText.asHtml(section_raw.data["description"], null, _htmlSerializer)
                });
                sections.push(result);
            })
            return sections;
        }, function (err) {
            return err;
        });
        return query;
    }
                    
    var getSiteAnnouncement = function () {
        var query = PrismicJS.getApi(api.endPoint, { accessToken: api.token }).then(function (api) {
            return api.query(
                PrismicJS.Predicates.at('document.type', 'page-announcement')
            );
        }).then(function (response) {
            var sections = [];
            response.results.forEach(function (section_raw) {
                var normalized = _normalizeBase(section_raw);
                var result = $.extend(normalized, {
                    title: PrismicDOM.RichText.asText(section_raw.data["title"]),
                    content: PrismicDOM.RichText.asHtml(section_raw.data["content"], null, _htmlSerializer)
                });
                sections.push(result);
            })
            return sections;
        }, function (err) {
            return err;
        });
        return query;
    }

    var getSiteNoticeOfIntents = function () {
        var query = PrismicJS.getApi(api.endPoint, { accessToken: api.token }).then(function (api) {
            return api.query(
                PrismicJS.Predicates.at('document.type', 'page-notice-of-intent')
            );
        }).then(function (response) {
            var contentRaw = (response.results.length) ? response.results[0] : undefined;
            if (!contentRaw) {
                return null;
            }

            var normalized = _normalizeBase(contentRaw);
            var result = $.extend(normalized, {
                title: PrismicDOM.RichText.asText(contentRaw.data["title"]),
                links: $.map(contentRaw.data["links"], function (link) {
                    return {
                        text: PrismicDOM.RichText.asText(link.text, null, _htmlSerializer),
                        link: link.link.url
                    }
                })
            });
            return result;
        }, function (err) {
            return err;
        });
        return query;
    }


    function formatDateForSafari(prismicDate) {
        // Date formatting for Safari Date constructor 
        // Calling new Date() fails for Safari 13 if the colon is not added to the timezone part

        if (prismicDate.indexOf('+') === -1) {
            return prismicDate;
        }

        var insertionPosition = prismicDate.indexOf('+') + 3;
        var formattedDate = prismicDate.slice(0, insertionPosition) + ":" + prismicDate.slice(insertionPosition);
        return formattedDate;
    }

    var _normalizeBase = function (item) {
        return {
            uid: item.uid,
            title: PrismicDOM.RichText.asText(item.data.title, null, _htmlSerializer),
            creation_date: formatDateForSafari(item.first_publication_date),
            modified_date: formatDateForSafari(item.last_publication_date)
        }
    }

    var _htmlSerializer = function (type, element, content, children) {
        switch (type) {
            case PrismicDOM.RichText.Elements.image:
                return '<img src="' + element.url + '" alt="' + element.alt + '" class="img-responsive">';
            default:
                return null;
        }
    };

    return {
        getTraining: getTraining,
        getContact: getContact,
        getFAQ: getFAQ,
        getNewFeatures: getNewFeatures,
        getSiteBanner: getSiteBanner,
        getEmergencyVendors: getEmergencyVendors,
        getSiteMaintenance: getSiteMaintenance,
        getSiteAnnouncement: getSiteAnnouncement,
        getSiteNoticeOfIntents: getSiteNoticeOfIntents
    };
})();
